<template>
  <v-app id="inspire">
    <div class="fill-height">
      <Header
        class="sheet"
        @toggleNavigationBar="toggleNavigationBar"
        v-show="!isPartnerLevel"
      ></Header>
      <release-notes-dialog ref="rn" />
      <new-course-alert-dialog />
      <Navigation
        v-if="isLoggedIn && !isPartnerLevel && !isadminLevel"
        class="blue-layout"
        :toggle="drawer"
        :force-open="tourNav"
      ></Navigation>
      <HeaderPartner v-show="isPartnerLevel"></HeaderPartner>
      <PartnerHubNavigation v-show="isPartnerLevel"></PartnerHubNavigation>
      <slideout-panel></slideout-panel>
      <v-main v-if="!isPartnerLevel" class="content-area">
        <slot />
        <!-- Renders nothing unless a Direct trial company admin (gate inside) -->
        <SetupGuide v-if="isLoggedIn" />
      </v-main>
      <v-main v-else-if="isPartnerLevel" class="pa-0">
        <slot />
      </v-main>
      <Footer></Footer>
      <!-- The Book a Demo tooltip used to render a full page backdrop here
           (60% black, position fixed, no z-index) that intercepted every
           click until its X was found. A "did you know" tip must not lock
           the product; the tooltip itself still shows and dismisses. -->
    </div>
  </v-app>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Header from '@/components/Header';
import Navigation from '@/components/Navigation';
import PartnerHubNavigation from '@/components/PartnerHubNavigation';
import HeaderPartner from '@/components/HeaderPartner';
import Footer from '@/components/Footer';
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog.vue';
import NewCourseAlertDialog from '@/components/NewCourseAlertDialog.vue';
import SetupGuide from '@/components/SetupGuide';

export default {
  name: 'LayoutBasic',
  components: {
    Header,
    Navigation,
    PartnerHubNavigation,
    Footer,
    Breadcrumb,
    HeaderPartner,
    ReleaseNotesDialog,
    NewCourseAlertDialog,
    SetupGuide,
  },
  data() {
    return {
      drawer: screen.width > 700 ? true : false,
      // The guided tour's request to show or hide the drawer (null = no
      // request). Below Vuetify's mobile breakpoint the drawer is temporary
      // and hides itself, taking every nav-anchored tour step with it.
      tourNav: null,
    };
  },
  created() {
    window.addEventListener('improve-tour-nav', this.onTourNav);
  },
  beforeDestroy() {
    window.removeEventListener('improve-tour-nav', this.onTourNav);
  },
  methods: {
    toggleNavigationBar() {
      this.drawer = !this.drawer;
    },
    onTourNav(e) {
      const open = e && e.detail && typeof e.detail.open === 'boolean' ? e.detail.open : null;
      this.tourNav = open;
      // On screens 1262px wide or less Navigation.selectedItem() also hides the
      // whole left navigation with display:none, and the hamburger lifts that
      // with style.display before opening (Header.toggleNavigationBar). The
      // tour has to do the same or the anchor has no box to point at.
      const el = document.getElementById('navbar-collapse');
      if (el && open !== null) {
        el.style.display = open || screen.width > 1262 ? 'block' : 'none';
      }
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isadminLevel() {
      return this.$store.getters.level === 1;
    },
    isPartnerLevel() {
      return this.$store.getters.level === 4 || this.$store.getters.level === 5;
    },
  },
};
</script>

<style media="screen">
.basic-layout {
  padding-bottom: 32px;
}
.v-application .blue-layout .v-toolbar.primary {
  background-color: #3497c5 !important;
  border-color: #3497c5 !important;
}
.content-area{
  padding-top: 0px !important;
}
</style>
